const schemaScheduleFilter = {
  sort_type: undefined,
  filter: undefined,
};

export default schemaScheduleFilter;
